'use strict';

const distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

exports.distance = distance;
exports.distance2D = distance2D;
//# sourceMappingURL=distance.cjs.map
